module.exports = __webpack_public_path__ + "img/audit.9421bc1c.svg";